import dawnImg from '../../assets/icons/dawn.png'
import dayImg from '../../assets/icons/day.png'
import duskImg from '../../assets/icons/dusk.png'
import nightImg from '../../assets/icons/night.png'

/**
 * LightPresetControl.js
 * Control nativo de Mapbox para cambiar lightPreset
 * Se integra con Redux para sincronización sin loops
 */

class LightPresetControl {
  constructor(initialPreset = 'day') {
    this._currentPreset = initialPreset
    this._expanded = false
    this._useTapExpand = true
    this.onPresetChange = null // Callback para Redux dispatch
  }

  onAdd(map) {
    this._map = map
    const icons = {
      dawn:  `<img src="${dawnImg}"  alt="Amanecer" style="width:20px;height:20px;object-fit:contain;display:block;" />`,
      day:   `<img src="${dayImg}"   alt="Día"       style="width:20px;height:20px;object-fit:contain;display:block;" />`,
      dusk:  `<img src="${duskImg}"  alt="Atardecer" style="width:20px;height:20px;object-fit:contain;display:block;" />`,
      night: `<img src="${nightImg}" alt="Noche"     style="width:20px;height:20px;object-fit:contain;display:block;" />`,
    }
    const presets = [
      { id: 'dawn', label: 'Amanecer', icon: icons.dawn },
      { id: 'day', label: 'Día', icon: icons.day },
      { id: 'dusk', label: 'Atardecer', icon: icons.dusk },
      { id: 'night', label: 'Noche', icon: icons.night },
    ]

    const container = document.createElement('div')
    container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group light-preset-ctrl'
    this._useTapExpand = true

    presets.forEach(({ id, label, icon }) => {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = `lp-btn lp-${id}`
      btn.title = label
      btn.setAttribute('aria-label', `Cambiar a ${label}`)

      btn.innerHTML = `
        <span class="lp-icon">${icon}</span>
        <span class="lp-tooltip">${label}</span>
      `

      if (id === this._currentPreset) {
        btn.classList.add('active')
      }

      btn.addEventListener('click', () => {
        const isActive = id === this._currentPreset

        if (this._useTapExpand && isActive && !this._expanded) {
          this._setExpanded(true)
          return
        }

        if (this._useTapExpand && isActive && this._expanded) {
          this._setExpanded(false)
          return
        }

        if (isActive && !this._useTapExpand) {
          return
        }

        // ✅ Remover active de todos
        container.querySelectorAll('.lp-btn').forEach(b => b.classList.remove('active'))
        btn.classList.add('active')
        this._currentPreset = id
        this._setExpanded(false)

        // ✅ Notificar a Redux (sin loops porque Redux lo sincroniza después)
        if (this.onPresetChange) {
          this.onPresetChange(id)
        }
      })

      container.appendChild(btn)
    })

    this._container = container
    return container
  }

  onRemove() {
    this._container?.remove()
    this._map = undefined
  }

  /**
   * Actualizar preset desde Redux
   */
  updatePreset(preset) {
    if (!this._map || !this._container || preset === this._currentPreset) return

    // Actualizar UI (remover/agregar active)
    const btn = this._container.querySelector(`.lp-${preset}`)
    if (btn) {
      this._container
        .querySelectorAll('.lp-btn')
        .forEach(b => b.classList.remove('active'))
      btn.classList.add('active')
      this._currentPreset = preset
      this._setExpanded(false)
    }
  }

  _setExpanded(expanded) {
    this._expanded = expanded
    if (!this._container) return
    if (expanded) {
      this._container.classList.add('is-expanded')
      return
    }
    this._container.classList.remove('is-expanded')
  }
}

export default LightPresetControl
